import React, { useEffect, lazy, Suspense } from "react";
import { motion } from "framer-motion";
import { useGLTF } from "@react-three/drei";
import ThreeViewer from "../../Components/Home/ThreeViewer";
import dtshirt from "../../images/3dtshirt.glb";
import { Tooltip } from "../../Components/UI/tooltip-card";
import ImagesCv from "../../Components/Home/ImagesCv";
import { ExpandableCardDemo } from "../../Components/Home/ExpandableCardDemo";
import { WobbleCardDemo } from "../../Components/Home/WobbleCardDemo";
import { SquigglyText } from "../../Components/UI/squiggly-text";
import { AccordionDemo } from "../../Components/Home/LastComp/AccardionDemo";
import LastComp from "../../Components/Home/LastComp/LastComp";
import Contact from "../../Components/Contact/Contact";
import Footerls from "../../Components/footer/Footerls";
import Hero from "../../Components/UI/animated-hero";
import { useNavigate } from "react-router-dom";
import { routes } from "../../Constants/Routes";
import mainimg from "../../images/main.png";
// const ThreeViewer = lazy(() => import("./ThreeViewer"));
const images = [
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
  "https://odditeesprinting.com/wp-content/uploads/2026/01/image-gen-9-scaled.png",
];

const Home = () => {
  useEffect(() => {
    useGLTF.preload("/3dtshirt.glb");
  }, []);
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 1, y: 30, filter: "blur(20px)", scale: 1.05 },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      scale: 1,
      transition: {
        duration: 0.9,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };
  const Config = [
    {
      title: "3D T-Shirt",
      src: dtshirt,
      scale: [4.2, 4, 4.2],
      position: [-8, -5, -2.9],
      rotation: [0, 0, 0],
    },
  ];
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-32 md:gap-56">
      <div>
        <motion.div initial="hidden" animate="show" variants={container}>
          <div className="relative flex h-[800px] clg:h-[900px] max-h-screen w-full items-center justify-center overflow-hidden  shadow-2xl">
            <motion.div
              variants={item}
              className="absolute  inset-0 flex items-center justify-center  "
            >
              <img
                src={mainimg}
                alt="main"
                className="w-full  h-full object-cover b   "
              />
            </motion.div>
            <motion.div
              variants={item}
              className="relative z-10 mx-auto flex max-w-4xl flex-col items-center gap-4 px-4 text-center"
            >
              {/* <h1 className="text-4xl font-bold tracking-tight text-neutral-800 md:text-6xl dark:text-neutral-100">
                State of the art, cutting edge images, everywhere.
              </h1> */}
              <div className="flex  h-[40rem]   w-[350px] ssxx:w-[405px] ssm:w-[475px] sfm:w-[1500px] flex-col gap-8 sm:gap-10 items-center justify-center px-4 text-center">
                <h1 className="font-bold text-3xl  ssxx:text-4xl w-full  sm:text-5xl mmd:text-6xl cxl:text-7xl leading-tight text-neutral-100">
                  პრემიუმ ხარისხის ბეჭდვა
                  <br />
                  და ბრენდინგი
                </h1>
                <h2 className=" text-sm ssxx:text-base sm:text-lg mmd:text-xl w-[300px] sfm:w-[400px] lg:w-[560px]  cxl:text-2xl font-semibold text-white font-ArialGeo leading-7">
                  მაღალი ხარისხის DTF ბეჭდვა ინდივიდუალური და კორპორატიული
                  შეკვეთებისთვის.
                </h2>
                <button
                  onClick={() => navigate(routes.GetOrder)}
                  className="
    relative
    border-none
    bg-transparent
    cursor-pointer
    transition-all
    duration-300
    pb-[10px]
    pl-[2px]
    mr-[10px]
    text-[18px]
    sfm:text-[20px] mmd:text-[24px]
    uppercase
    tracking-[4px]
    text-white
    active:scale-90

    before:content-['⇝']
    before:absolute
    before:text-[48px]
    before:top-[-26px]
     sfm:before:top-[-24px] mmd:before:top-[-22px]
    before:right-[-10px]
    before:translate-x-full

    after:content-['']
    after:absolute
    after:left-0
    after:bottom-0
    after:h-[2px]
    after:w-full
    after:bg-white
    after:origin-bottom-right
    after:scale-x-0
    after:transition-transform
    after:duration-300

    hover:after:scale-x-100
    hover:after:origin-bottom-left
  "
                >
                  შეუკვეთე
                </button>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
      <motion.div
        initial={{ opacity: 0, scale: 0.9, filter: "blur(20px)" }}
        whileInView={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
        transition={{
          duration: 0.7,
          delay: 0,
          ease: [0.25, 0.1, 0.25, 1],
        }}
        viewport={{ once: true, amount: 0.4 }}
      >
        <div className="relative  w-full max-w-9xl mx-auto px-2 sfm:px-4 lg:px-1 xl:px-5 clg:px-14 cxl:px-4 py-5 flex flex-col lg:flex-row gap-5 xl:gap-4 cxl:gap-10 items-center justify-center">
          <div className="w-full lg:flex-1 max-w-[600px] aspect-square p-4 lg:p-2 xl:p-4 ">
            <motion.div
              layoutId={`card-${Config[0].title}`}
              className="flex h-full flex-col  relative right-6 ssmm:right-8 sfm:right-10  lg:right-0  cursor-pointer bg-cover bg-center bg-no-repeat"
            >
              <div className="w-full  h-full">
                <Suspense fallback={<div>Loading 3D...</div>}>
                  <ThreeViewer />
                </Suspense>
              </div>
            </motion.div>
          </div>

          <div className="w-full lg:flex-1 max-w-3xl xxl:max-w-4xl pt-0 p-0 sfm:p-2 cxl:p-5">
            <h1 className="text-3xl xsxm:text-4xl cxl:text-5xl text-black font-Mtavruli">
              ჩვენს შესახებ
            </h1>

            <p className="pl-1 mt-3 ssm:mt-5 text-sm ssxx:text-md ssm:text-lg smm:text-xl lg:text-lg cxl:text-xl font-semibold font-ArialGeo text-black ">
              ჩვენ ბაზარზე 2023 წლიდან ვმოღვაწეობთ და ამ დროის განმავლობაში უკვე
              მოვიპოვეთ სანდო სახელი — ცნობილი ვართ სტაბილური შედეგებით,
              ეფექტური წარმოებითა და უმაღლესი ხარისხის პროდუქციით.
            </p>

            <p className="pl-1 mt-2 ssm:mt-5 text-sm ssxx:text-md ssm:text-lg smm:text-xl lg:text-lg cxl:text-xl font-semibold font-ArialGeo text-black">
              ჩვენი მთავარი მიზანია თითოეულ მომხმარებელზე ინდივიდუალური ზრუნვა
              და მათთან გრძელვადიანი პარტნიორული ურთიერთობების ჩამოყალიბება.
              ჩვენ ვაანალიზებთ თითოეული კლიენტის საჭიროებებს და ვთავაზობთ მათზე
              მორგებულ გადაწყვეტილებებს.
            </p>

            <p className="pl-1 mt-2 ssm:mt-5 text-sm ssxx:text-md ssm:text-lg smm:text-xl lg:text-lg cxl:text-xl font-semibold font-ArialGeo text-black">
              სწორედ ამ მიდგომამ მოგვცა შესაძლებლობა, რომ მუდმივად განვვითარდეთ
              და მოვერგოთ როგორც ადგილობრივი, ისე საერთაშორისო ბაზრის
              მოთხოვნებს.
            </p>
          </div>
        </div>
      </motion.div>
      <div>
        <ExpandableCardDemo />
      </div>
      <div>
        {/* <ImagesCv /> */}
        <WobbleCardDemo />
      </div>
      <div>
        <LastComp />
      </div>
      {/* <div>
          <Contact />
        </div> */}
      <div>
        <div className="block">
          <Hero />
        </div>
      </div>
      <div>
        <Footerls />
      </div>
    </div>
  );
};
const TooltipCard = () => {
  return (
    <div>
      <img
        src="https://assets.aceternity.com/screenshots/tyler.webp"
        alt="Tyler Durden"
        className="aspect-square w-full rounded-sm"
      />
      <div className="my-4 flex flex-col">
        <p className="text-lg font-bold">Tyler Durden</p>
        <p className="mt-1 text-xs text-neutral-600 dark:text-neutral-400">
          Soap Developer from a Tier 3 college. Enthusiastic and exhibits
          entrepreneurial spirit.
        </p>
      </div>
    </div>
  );
};

const TestimonialCard = () => {
  return (
    <div className="">
      <blockquote className="mb-4 text-neutral-700 dark:text-neutral-300">
        This product is absolutely, grade A horse shit.
      </blockquote>
      <div className="flex items-center gap-2">
        <img
          src="https://assets.aceternity.com/screenshots/tyler.webp"
          alt="Tyler Durden"
          className="size-6 rounded-full object-cover"
        />
        <div>
          <p className="text-xs font-semibold text-neutral-900 dark:text-neutral-100">
            Tyler Durden
          </p>
          <p className="text-[10px] text-neutral-600 dark:text-neutral-400">
            Senior Product Manager at FC
          </p>
        </div>
      </div>
    </div>
  );
};
export default Home;
